import { render, staticRenderFns } from "./MetersToBeach.vue?vue&type=template&id=0a8ce438&lang=pug"
import script from "./MetersToBeach.vue?vue&type=script&lang=js"
export * from "./MetersToBeach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports